import React from 'react';
import { motion } from 'framer-motion';
import { Battery, BatteryMedium, Flame } from 'lucide-react';
export function AntiAbandonoSection() {
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-13">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="space-y-8" data-id="element-14">
        <div data-id="element-15">
          <h2 className="text-3xl font-bold text-white mb-2" data-id="element-16">
            ¿Y si me falta constancia?
          </h2>
          <p className="text-2xl text-[#25F4EE] font-bold" data-id="element-17">
            Perfecto. Está diseñado para eso.
          </p>
        </div>

        <p className="text-lg text-gray-300" data-id="element-18">
          El sistema incluye el{' '}
          <span className="text-white font-bold" data-id="element-19">Tablero Anti-Abandono</span>,
          para el punto crítico:{' '}
          <span className="text-[#FE2C55] font-bold" data-id="element-20">el Día 8</span>, cuando
          baja la dopamina y tu mente empieza a negociar.
        </p>

        <p className="text-lg text-gray-300" data-id="element-21">
          En lugar de "deberías ser disciplinado", vas a tener:
        </p>

        <div className="space-y-3" data-id="element-22">
          {/* Modo Mínimo */}
          <div className="flex items-center gap-4 bg-[#111] p-4 rounded-xl border border-white/5" data-id="element-23">
            <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-24">
              <Battery className="w-5 h-5 text-gray-400" data-id="element-25" />
            </div>
            <div data-id="element-26">
              <h3 className="text-white font-bold" data-id="element-27">Modo Mínimo</h3>
              <p className="text-sm text-gray-400" data-id="element-28">9 segundos, y listo</p>
            </div>
          </div>

          {/* Modo Estándar */}
          <div className="flex items-center gap-4 bg-[#111] p-4 rounded-xl border border-white/10" data-id="element-29">
            <div className="w-10 h-10 rounded-full bg-[#25F4EE]/10 flex items-center justify-center" data-id="element-30">
              <BatteryMedium className="w-5 h-5 text-[#25F4EE]" data-id="element-31" />
            </div>
            <div data-id="element-32">
              <h3 className="text-white font-bold" data-id="element-33">Modo Estándar</h3>
              <p className="text-sm text-gray-400" data-id="element-34">Cumpliendo el plan</p>
            </div>
          </div>

          {/* Modo Fuego */}
          <div className="flex items-center gap-4 bg-gradient-to-r from-[#FE2C55]/10 to-transparent p-4 rounded-xl border border-[#FE2C55]/20" data-id="element-35">
            <div className="w-10 h-10 rounded-full bg-[#FE2C55]/20 flex items-center justify-center" data-id="element-36">
              <Flame className="w-5 h-5 text-[#FE2C55]" data-id="element-37" />
            </div>
            <div data-id="element-38">
              <h3 className="text-white font-bold" data-id="element-39">Modo Fuego 🔥</h3>
              <p className="text-sm text-gray-400" data-id="element-40">Máxima energía</p>
            </div>
          </div>
        </div>

        <p className="text-2xl font-black text-white text-center pt-4" data-id="element-41">
          No importa tu estado:{' '}
          <span className="text-[#FE2C55] underline decoration-4 decoration-[#FE2C55]/30" data-id="element-42">
            publicas
          </span>
          .
        </p>
      </motion.div>
    </section>;
}